<template>
  <v-app>
    <v-main app>
      <v-container fluid class="pa-0">
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { computed } from 'vue'

const route = useRoute()


const breadcrumbs = computed(() => {
  return (route.meta?.breadcrumb ?? []).map(item => ({
    title: item.text,
    disabled: !item.to,
    to: item.to || undefined
  }))
})

const logout = () => {
  localStorage.removeItem('token')
  router.push('/')
}

</script>

<style scoped>
</style>
